// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Xb9D","log":"ModalInventoryLogs_log__3E_if","date":"ModalInventoryLogs_date__3t3Ha","userName":"ModalInventoryLogs_userName__2Cty2"};